import { render, staticRenderFns } from "./PixEditView.vue?vue&type=template&id=9612e52e&scoped=true&"
import script from "./PixEditView.vue?vue&type=script&lang=ts&"
export * from "./PixEditView.vue?vue&type=script&lang=ts&"
import style0 from "./PixEditView.vue?vue&type=style&index=0&id=9612e52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9612e52e",
  null
  
)

export default component.exports